import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { ILessonClient } from '../services/lesson-client';
import { LessonClient } from '../services/lesson-client-impl';
import { useErrorHandler } from './ErrorHandlerContext';

interface LessonClientProviderProps {
  children: ReactNode;
}

const LessonClientContext = createContext<ILessonClient | undefined>(undefined);

export const LessonClientProvider: React.FC<LessonClientProviderProps> = ({ children }) => {
  const { handleError } = useErrorHandler();
  const lessonClient = useMemo(() => new LessonClient(handleError), [handleError]);



  return (
    <LessonClientContext.Provider value={lessonClient}>
      {children}
    </LessonClientContext.Provider>
  );
};

export const useLessonClient = (): ILessonClient => {
  const context = useContext(LessonClientContext);
  if (context === undefined) {
    throw new Error('useLessonClient must be used within a LessonClientProvider');
  }
  return context;
}; 